import { ColumnsMenu, LegendPopover } from "./TablePopovers";
import { WORKLIST_COLUMNS } from "./columns";
import type { propsSenzaPermesso } from "@/shared/auth/permessi";
import type { useColumnLayout } from "../useColumnLayout";

/** I tasti secondari della plancia (Esporta, Legenda, Colonne): pillola
 *  bianca come i filtri della lista ordini. */
const TASTO_PILL =
  "inline-flex h-[34px] items-center gap-1.5 whitespace-nowrap rounded-full border border-line-2 bg-card px-3.5 text-[12.5px] font-semibold text-ink transition-colors hover:border-ink-4 disabled:opacity-50";

/** La riga strumenti della plancia Fatture: Sincronizza, Riga manuale,
 *  Esporta Excel a sinistra, Legenda e Colonne a destra. */
export function StrumentiFatture({
  syncBusy,
  onSync,
  onRigaManuale,
  senzaPermesso,
  exportBusy,
  onEsporta,
  layout,
}: {
  syncBusy: boolean;
  onSync: () => void;
  onRigaManuale: () => void;
  senzaPermesso: ReturnType<typeof propsSenzaPermesso>;
  exportBusy: boolean;
  onEsporta: () => void;
  layout: ReturnType<typeof useColumnLayout>;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-t border-line pt-3">
      <button
        type="button"
        data-sync
        disabled={syncBusy}
        aria-busy={syncBusy}
        onClick={onSync}
        title="Rileva ordini nuovi, NC, arricchisce i dati, verifica le anagrafiche e riconcilia col registro Eureka (specchiato via ponte) senza aspettare il giro automatico."
        {...senzaPermesso}
        className="inline-flex h-[34px] items-center gap-2 rounded-full border border-violet bg-violet px-4 text-[12.5px] font-semibold text-white transition-colors hover:border-violet-2 hover:bg-violet-2 disabled:cursor-not-allowed disabled:opacity-55"
      >
        <svg
          className={`h-[14px] w-[14px] fill-none stroke-current stroke-[1.8] [stroke-linecap:round] [stroke-linejoin:round] ${syncBusy ? "animate-spin" : ""}`}
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M20 11a8 8 0 0 0-14.9-3.5M4 4v4h4M4 13a8 8 0 0 0 14.9 3.5M20 20v-4h-4" />
        </svg>
        {syncBusy ? "Sincronizzo…" : "Sincronizza"}
      </button>
      <button
        type="button"
        onClick={onRigaManuale}
        {...senzaPermesso}
        className="inline-flex h-[34px] items-center rounded-full border border-ink bg-ink px-4 text-[12.5px] font-semibold text-on-ink transition-[filter] hover:brightness-125 disabled:cursor-not-allowed disabled:opacity-50"
      >
        + Riga manuale
      </button>
      <button
        type="button"
        disabled={exportBusy}
        onClick={onEsporta}
        title="Scarica in Excel la vista corrente (tab, ricerca e filtri applicati; max 5000 righe)"
        className={TASTO_PILL}
      >
        {exportBusy ? "Esporto…" : "Esporta Excel"}
      </button>
      <div className="ml-auto flex items-center gap-2">
        <LegendPopover />
        <ColumnsMenu
          columns={WORKLIST_COLUMNS}
          hidden={layout.hidden}
          onToggle={layout.toggleHidden}
          onReset={layout.reset}
        />
      </div>
    </div>
  );
}
